import { v4 as uuidv4 } from 'uuid';

const CLIENT_ID_KEY = 'client_id';

/**
 * 获取客户端唯一的 client_id (UUID)
 * 如果本地存储中不存在，则自动生成并存入 localStorage
 */
export function getClientId(): string {
  let clientId = localStorage.getItem(CLIENT_ID_KEY);
  if (!clientId) {
    clientId = uuidv4();
    localStorage.setItem(CLIENT_ID_KEY, clientId);
  }
  return clientId;
}
